export const PAYMENT_STATUS = {
  OPEN: 'OPEN',
  DRAFT: 'DRAFT',
  PAID: 'PAID',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE',
  VOID: 'VOID',
};

export const DEFAULT_INVOICES = {
  items: [],
  meta: {
    currentPage: 0,
    itemsPerPage: 0,
    totalItems: 0,
    totalPages: 0,
  },
};
